// @ts-strict-ignore
import React from 'react'
import ReactMarkdown from 'react-markdown'
import { List, ListItem, ListItemText, ListItemIcon, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import DoneIcon from '@mui/icons-material/Done'
import { makeStyles } from 'tss-react/mui'
import Condition from 'components/Condition'

const useStyles = makeStyles()(theme => ({
  textDescription: {
    '& p + p': {
      marginTop: theme.spacing(4),
    },
  },
  contentListItemIcon: {
    position: 'relative',
    backgroundColor: 'rgba(51, 153, 255, 0.08)',
    boxShadow: '0 0 0 6px  rgba(51, 153, 255, 0.08)',
    borderRadius: '100%',
    opacity: 0.9,
    minWidth: '24px !important',
    marginRight: theme.spacing(4),
    color: theme.palette.secondary.dark,
    '& *': {
      color: theme.palette.secondary.dark,
    },
  },
  content: {
    padding: 0,
    '& p:first-child': {
      marginTop: '0 !important',
    },
    '& h1:first-child': {
      marginTop: '0 !important',
    },
    '& h2:first-child': {
      marginTop: '0 !important',
    },
    '& h3:first-child': {
      marginTop: '0 !important',
    },
    '& h4:first-child': {
      marginTop: '0 !important',
    },
    '& h5:first-child': {
      marginTop: '0 !important',
    },
    '& h6:first-child': {
      marginTop: '0 !important',
    },
    '& ul:first-child': {
      marginTop: '0 !important',
    },
    '& ol:first-child': {
      marginTop: '0 !important',
    },
    '& h1': {
      marginTop: theme.spacing(4),
    },
    '& h2': {
      marginTop: theme.spacing(4),
    },
    '& h3': {
      marginTop: theme.spacing(4),
    },
    '& h4': {
      marginTop: theme.spacing(4),
    },
  },
}))

export interface IRichTextDescriptionProps {
  text: string
  title?: string
  style?: React.CSSProperties
  contentStyle?: React.CSSProperties
  children?: React.ReactNode
}

export default function RichTextDescription(props: IRichTextDescriptionProps) {
  const { classes } = useStyles()
  const theme = useTheme()
  const { text, title, contentStyle, children, ...restProps } = props

  if (!text) {
    return null
  } if (typeof text === 'string' && !text.replace(' ', '')) {
    return null
  }

  return (
    <div className={classes.textDescription} {...restProps}>
      <Condition condition={Boolean(title)}>
        <Typography variant="h3">
          {title}
        </Typography>
      </Condition>

      <div className={classes.content} style={contentStyle}>
        <ReactMarkdown
          source={text || ''}
          renderers={{
            heading: params => (
              <Typography variant="h4" gutterBottom style={{ margin: theme.spacing(2, 0) }}>
                {params.children?.[0]?.props?.children}
              </Typography>
            ),
            paragraph: params => (
              <Typography variant="body1" component="p" style={{ margin: theme.spacing(2, 0) }}>
                {params.children}
              </Typography>
            ),
            list: params => (
              <List style={{ margin: theme.spacing(2, 0, 3, 0) }} dense disablePadding>
                {params.children}
              </List>
            ),
            listItem: params => (
              <ListItem style={{ paddingLeft: theme.spacing(2) }}>
                <ListItemIcon className={classes.contentListItemIcon}>
                  <DoneIcon />
                </ListItemIcon>

                <ListItemText primary={params.children} />
              </ListItem>
            ),
          }}
        />
      </div>
    </div>
  )
}
